module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/15.c7a9c2cd.png";